import { globalStorage } from '@app/storage';
import { MLanguageCategory } from '@elte/translate-backend/interface/lang_category';
import { MLanguageFiles } from '@elte/translate-backend/interface/lang_file';
import { MLanguageFilesAccepted } from '@elte/translate-backend/interface/lang_files_accepted';
import { MUsers } from '@elte/translate-backend/interface/users';
import auth from '@feathersjs/authentication-client';
import { feathers, ServiceMethods } from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import axios from 'axios';

export type ServiceMethodsLangCategory = ServiceMethods<MLanguageCategory.DataLanguageCategory>;
export type ServiceMethodsLangFile = ServiceMethods<MLanguageFiles.TResponseLanguageFiles>;
export type ServiceMethodsLangFilesAccepted = ServiceMethods<MLanguageFilesAccepted.TResponseFind>;
export type ServiceMethodsUsers = ServiceMethods<MUsers.UserData>;

const app = feathers<{
    lang_category: ServiceMethodsLangCategory;
    lang_file: ServiceMethodsLangFile;
    lang_files_accepted: ServiceMethodsLangFilesAccepted;
    users: ServiceMethodsUsers;
}>();

// Connect to the same as the browser URL (only in the browser)
const restClient = rest('/api');

app.configure(restClient.axios(axios));
app.hooks({
    error(e) {
        if (e.error && e.error.code === 401) {
            globalStorage.openErrorUnAuthenticated = true;
        }
    }
});

app.configure(
    auth({
        storageKey: 'apiToken'
    })
);

export { app };
